// extracted by mini-css-extract-plugin
module.exports = {"mainComponent":"style_mainComponent__3A3f8","mainContent":"style_mainContent__1DYYd","rightContainer":"style_rightContainer__1b-UG"};